import { Box, Heading, Text } from "@chakra-ui/react";
import React from "react";

export default function Intro() {
  return (
    <Box
      align="left"
      width="100%"
      height={"700px"}
      margin={"auto"}
      paddingTop={20}
      paddingBottom={20}
      bgImage={'"images/dev.jpg"'} 
      mt={20}
      id="home"
      
    >
      <Box
        align="left"
        width="80%"
        margin={"auto"}
        paddingTop={10}
        
        mt={20}
      >
        <Box bg={"blackAlpha.600"} width={['100%','700px','700px','700px','700px']} borderRadius={10} padding={5}>
        <Text color={"cplite"} fontSize={20}>
          Hi, my name is
        </Text>
        <Heading fontSize={{ base: 40, md: 60}} color={"cpdark"}>
          SUHAIL K.
        </Heading>
        <Heading color={"cpnormal"} fontSize={{ base: 30, md: 50}}>
          I build things for the web.
        </Heading>
        <br />
        <Text color={"white"} fontSize={{ base: 15, md: 20}}>
        Turning ideas into reality with expert coding skills and an innovative approach.
        </Text>
        </Box>
      </Box>
    </Box>
  );
}
